import globalEventBus from 'toxilibs/event_bus_queued.js'
import style from './style.js'
import getUrlParams from 'toxilibs/url_params.js'

let eventBus = globalEventBus('renderer')


let {colorblind: colorBlindMode} = getUrlParams()

let screen

eventBus.on('screen loaded', function (_screen) {
    screen = _screen
})


let map

eventBus.on('map loaded', function (_map) {
    map = _map
    updateRenderDimensions()
})



let roundedSquareMode
let cellRadius

eventBus.on('challenge loaded', function (challenge) {
    roundedSquareMode = challenge.roundedSquares
    cellRadius = style.cellRadius * (roundedSquareMode ? 1.15 : 1)
})


eventBus.on('screen has been reset', render)

eventBus.on('world reset', render)

eventBus.on('cell color updated', render)


function updateRenderDimensions () {
    eventBus.emit('map render dimensions changed', {
        width:  dimensionToRender('width'),
        height: dimensionToRender('height'),
        center: {
            x: (map.width  - 1) / 2,
            y: (map.height - 1) / 2
        }
    })
}


function dimensionToRender (dimension) {
    let borderSpacing = false

    let spacingsCount = map[dimension] + (borderSpacing ? 1 : -1)
    return spacingsCount + 2 * cellRadius * (map[dimension] - spacingsCount)
}


function render () {
    if (!screen || !map) {
        return
    }
    screen.clear({
        layer: 0
    })
    map.forEachCell(renderCell)
}


function renderCell (cell) {

    let fillColor = style.colors[cell.color]

    if (roundedSquareMode) {
        screen.drawRectangle({
            layer:     0,
            center:    cell,
            width:     2 * cellRadius,
            height:    2 * cellRadius,
            roundedCorners: 0.3,
            fillColor
        })
    } else {
        screen.drawCircle({
            layer:     0,
            center:    cell,
            radius:    cellRadius,
            fillColor
        })
    }

    if (colorBlindMode && cell.color !== 'normal') {
        screen.drawText({
            layer:     0,
            center:   cell,
            font: '0.9u sans-serif',
            text:  cell.color.toUpperCase()[0],
            color: 'white',
            opacity: 0.6
        })
    }


}


